//import logo from './logo.svg';
import "./App.css";
import MainView from "./MainView";
import logo from "./assets/logo-irta.png";
import logoCrag from "./assets/logo-crag.png";
import SequenceView from "./SequenceView";

import { useState, useRef} from "react";

import {ReactComponent as Logo} from "./assets/genovarviewlogo.svg";


function App() {
	const sequenceView = useRef(null);
	const scrollToSequenceView = () => {
		sequenceView.current.scrollIntoView({ behavior: "smooth" });
	};
	const [fastas, setFasta] = useState({});
	const [annotations, setAnnotations] = useState({});
	const setFastaAndScroll = (fastas) => {
		setFasta(fastas);
		if (fastas && !(Object.keys(fastas).length === 0 && Object.getPrototypeOf(fastas) === Object.prototype))
			scrollToSequenceView();
	}
	const [form, setForm] = useState({});
	return (
		<div className="App mt-3">
			<header className="App-header">
				<h1 className="display-1"><Logo style={{height:"100px"}}/> GenoVarView</h1>
				<p className="lead">
					A Genomic Region Analysis and Visualization Tool.
				</p>
			</header>
			<MainView onFastaGenerated={setFastaAndScroll} onFormUpdated={setForm} onAnnotationsLoaded={setAnnotations}/>
			
			<div ref={sequenceView} className="my-5">
            	<SequenceView fastas={fastas} form={form} annotations={annotations}/>
            </div>
			<div className="container">
				<footer className="py-3 my-4 border-top ">
					<div className="container">
						<a href="/" className="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
							<svg className="bi" width="30" height="24"></svg>
						</a>
						<span className="mb-3 mb-md-0 text-muted">
							<img
								className=""
								style={{
									height: "1.5rem",
									position: "relative",
									top: "-2px",
								}}
								src={logo}
								alt="IRTA"
							/>
							&nbsp;&nbsp;
							<img
								className=""
								style={{
									height: "2rem",
									position: "relative",
									top: "-2px",
								}}
								src={logoCrag}
								alt="IRTA"
							/>						
						</span>
					</div>

					<ul className="nav justify-content-center pb-3 mb-3 mt-3 text-muted">
						<li className="ms-3">Beatriz García-Gómez</li>
						<li className="ms-3">Carles Onielfa</li>
						<li className="ms-3">María José Aranzana</li>
					</ul>
				</footer>
			</div>
		</div>
	);
}

export default App;
